import { TAGS_ACTION_TYPES } from "../actions/tagsActions";

// Initial State
export const initialTagsState = {
  tags: [],
  tagTypes: [],
  loading: false,
  error: null,
};

// Reducer
export const tagsReducer = (state = initialTagsState, action) => {
  switch (action.type) {
    case TAGS_ACTION_TYPES.SET_TAGS_DATA:
      return {
        ...state,
        tags: action.payload,
        loading: false,
        error: null,
      };

    case TAGS_ACTION_TYPES.UPDATE_TAG_CHILDREN: {
      const { tagId, children } = action.payload;
      return {
        ...state,
        tags: state.tags.map((tag) => {
          if (tag.id === tagId) {
            return {
              ...tag,
              childTags: children,
            };
          }
          return tag;
        }),
      };
    }

    case TAGS_ACTION_TYPES.SET_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
